<template>
  <div>
    <v-card class="pa-3">
      <div class="text-xs-right">
        <v-btn fab @click="onClose" small flat><v-icon>close</v-icon></v-btn>
      </div>

      <v-layout wrap>
        <v-flex xs12 sm12>
          <h1>{{ action == 'add' ? $t('add_service_center') : $t('edit_service_center') }}</h1>
        </v-flex>
        <v-flex xs12 sm12>
          <div class="pa-1">
            <v-checkbox v-model="input.fastlane" label="Fast lane" color="primary"></v-checkbox>
          </div>
        </v-flex>
        <v-flex xs12 sm12>
          <div
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('service_center_name') }"
          >
            <div>
              <label for="service_center_name" class="caption">
                {{ $t('secap_service_center_name') }} <span class="red--text">*</span>
              </label>
            </div>
            <input
              :data-vv-as="$t('secap_service_center_name')"
              v-validate="'required'"
              name="service_center_name"
              v-model="input.name"
              class="form-control"
              type="text"
            />
            <span class="text-error" v-show="errors.has('service_center_name')">
              {{ errors.first('service_center_name') }}
            </span>
          </div>
        </v-flex>
        <v-flex xs12 sm12>
          <div class="form-control pa-1" :class="{ 'has-error': errors.has('branch') }">
            <div>
              <label for="branch" class="caption"
                >{{ $t('secap_branch') }} <span class="red--text">*</span></label
              >
            </div>
            <input
              :data-vv-as="$t('secap_branch')"
              name="branch"
              v-model="input.branch"
              class="form-control"
              type="text"
              v-validate="'required'"
            />
            <span class="text-error" v-show="errors.has('branch')">
              {{ errors.first('branch') }}
            </span>
          </div>
        </v-flex>
        <v-flex xs12 sm6 class="px-1">
          <div class="form-control" :class="{ 'has-error': errors.has('province') }">
            <div>
              <label for="province" class="caption"
                >{{ $t('Province') }} <span class="red--text">*</span></label
              >
            </div>
            <thai-address-input
              v-model="input.province"
              type="province"
              @select="onSelectAddress"
              :placeholder="$t('Province')"
            />
            <input
              type="hidden"
              name="province"
              :data-vv-as="$t('Province')"
              v-model="input.province"
              v-validate="'required'"
            />

            <span class="text-error" v-if="errors.has('province')">{{
              errors.first('province')
            }}</span>
          </div>
        </v-flex>
        <v-flex xs12 sm6 class="px-1">
          <div class="form-control" :class="{ 'has-error': errors.has('district') }">
            <div>
              <label for="district" class="caption"
                >{{ $t('District') }} <span class="red--text">*</span></label
              >
            </div>
            <thai-address-input
              v-model="input.district"
              type="amphoe"
              @select="onSelectAddress"
              :placeholder="$t('District')"
            />
            <input
              type="hidden"
              name="district"
              :data-vv-as="$t('District')"
              v-model="input.district"
              v-validate="'required'"
            />
            <span class="text-error" v-if="errors.has('district')">{{
              errors.first('district')
            }}</span>
          </div>
        </v-flex>
        <v-flex xs12 sm12>
          <div class="form-control pa-1" :class="{ 'has-error': errors.has('address') }">
            <div>
              <label for="address" class="caption"
                >{{ $t('Address') }} <span class="red--text">*</span></label
              >
            </div>
            <textarea
              name="address"
              id="address"
              style="width: 100%; min-height: 100px"
              :data-vv-as="$t('Address')"
              class="form-control"
              v-model="input.address"
              :placeholder="$t('Address')"
              v-validate="'required'"
            ></textarea>
            <span class="text-error" v-show="errors.has('address')">
              {{ errors.first('address') }}
            </span>
          </div>
        </v-flex>
        <v-flex xs12 sm12>
          <div class="form-control pa-1">
            <label for="car_brand" class="caption">{{ $t('secap_car_brand') }}</label>
            <multiselect
              ref="car_brand"
              name="car_brand"
              :data-vv-as="$t('secap_car_brand')"
              v-model="input.car_brand"
              :options="brandOptions"
              selectLabel
              selectedLabel
              :allow-empty="true"
              :searchable="false"
              open-direction="top"
            ></multiselect>
          </div>
        </v-flex>
        <v-flex xs12 sm12>
          <div class="form-control pa-1">
            <label for="store_brand" class="caption">{{ $t('shop') }}</label>
            <multiselect
              ref="store_brand"
              name="store_brand"
              :data-vv-as="$t('shop')"
              v-model="input.store_brand"
              :options="storeOptions"
              selectLabel
              selectedLabel
              :allow-empty="true"
              :searchable="false"
              open-direction="top"
            ></multiselect>
          </div>
        </v-flex>
        <v-flex xs12 sm12>
          <div class="form-control pa-1" :class="{ 'has-error': errors.has('store_type') }">
            <label for="store_type" class="caption"
              >{{ $t('secap_service_center_type') }} <span class="red--text">*</span></label
            >
            <multiselect
              ref="store_type"
              name="store_type"
              :data-vv-as="$t('secap_service_center_type')"
              v-model="input.store_type"
              :options="storeTypes"
              selectLabel
              selectedLabel
              :allow-empty="false"
              :searchable="false"
              open-direction="top"
              v-validate="'required'"
              deselect-label
            ></multiselect>
          </div>
        </v-flex>
        <v-flex xs12 xm12 class="text-xs-center">
          <v-btn @click="onClose" outline color="grey">{{ $t('cancel') }}</v-btn>
          <v-btn :loading="saveloading" @click="onSave" depressed color="primary">{{
            $t('Save')
          }}</v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import ThaiAddressInput from '@/components/elements/ThaiAddressInput'
import Multiselect from 'vue-multiselect'

export default {
  props: ['value', 'action'],
  components: {
    ThaiAddressInput,
    Multiselect
  },
  data() {
    return {
      saveloading: false,
      input: {
        name: '',
        branch: '',
        province: '',
        district: '',
        address: '',
        car_brand: '',
        store_brand: '',
        store_type: '',
        fastlane: false
      },
      brandOptions: [
        'BMW',
        'Honda',
        'Hyundai',
        'Isuzu',
        'LEXUS',
        'Mazda',
        'Mercedes-Benz',
        'MG',
        'Mitsubishi',
        'Nissan',
        'Toyota',
        'Volk Swagen',
        'Volvo'
      ],
      storeOptions: [
        'ACT',
        'AUTOBOY',
        'B-Quick',
        'Bridgestone',
        'COCKPIT',
        'DLR',
        'Fit Auto',
        'Toyota'
      ],
      storeTypes: ['ศูนย์ใน (ไม่ระบุยี่ห้อ)', 'ศูนย์ใน (ระบุยี่ห้อ)', 'ศูนย์นอก (ระบุยี่ห้อ)']
    }
  },
  mounted() {
    if (this.value) {
      this.input = {
        name: this.value.name,
        branch: this.value.branch,
        province: this.value.province,
        district: this.value.district,
        address: this.value.address,
        car_brand: this.value.car_brand,
        store_brand: this.value.store_brand,
        store_type: this.value.store_type,
        fastlane: this.value.fastlane
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    onSave() {
      if (this.action == 'add') {
        this.addStore()
      } else {
        this.updateStore()
      }
    },
    addStore() {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid,
        name: vm.input.name,
        province: vm.input.province,
        branch: vm.input.branch,
        address: vm.input.address,
        district: vm.input.district,
        car_brand: vm.input.car_brand,
        store_brand: vm.input.store_brand,
        store_type: vm.input.store_type,
        fastlane: vm.input.fastlane
      }

      vm.saveloading = true
      api.addSecapMaintenanceStores(data, (err, response) => {
        vm.saveloading = false
        if (err) {
          console.error(err)
          return
        }

        if (response.responsecode == 200) {
          let text = `${vm.$t('add_service_center')}${vm.$t('Success')}`
          vm.$swal.fire({
            type: 'success',
            text: text
          })

          vm.clearForm()
          vm.$emit('success')
        }
      })
    },
    updateStore() {
      let vm = this
      let data = {
        id: vm.value.id,
        pageid: vm.selectedBot.pageid,
        name: vm.input.name,
        province: vm.input.province,
        branch: vm.input.branch,
        address: vm.input.address,
        district: vm.input.district,
        car_brand: vm.input.car_brand,
        store_brand: vm.input.store_brand,
        store_type: vm.input.store_type,
        fastlane: vm.input.fastlane
      }

      vm.saveloading = true
      api.updateSecapMaintenanceStores(data, (err, response) => {
        vm.saveloading = false
        if (err) {
          console.error(err)
          return
        }

        if (response.responsecode == 200) {
          let text = `${vm.$t('edit_service_center')}${vm.$t('Success')}`
          vm.$swal.fire({
            type: 'success',
            text: text
          })

          vm.clearForm()
          vm.$emit('success')
        }
      })
    },
    onSelectAddress(address) {
      this.input.district = address.amphoe
      this.input.province = address.province
    },
    onClose() {
      this.clearForm()
      this.$emit('close')
    },
    clearForm() {
      this.input = {
        name: '',
        branch: '',
        province: '',
        district: '',
        address: '',
        car_brand: '',
        store_brand: '',
        store_type: '',
        fastlane: false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/secap/ServiceCenterDialog.vue